import React, { useState, useRef, useEffect, useContext } from 'react'
import { Grid } from 'theme-ui'
import QuickAddProductCard from '~/components/Product/QuickAddCard'
import BikeQuickAddCard from '~/components/Product/QuickAddCard/Bike'
import { useOnScreen } from '~/hooks/utils/use-on-screen'
import FilterContext from '~/contexts/FilterContext'
import _ from 'lodash'
import { useLocation } from '@reach/router'

const ProductList = ({ lineup, products, collectionName }) => {
  const [showAmount, setShowAmount] = useState(12)
  const [activeFilters, setActiveFilters] = useContext(FilterContext)
  const { pathname } = useLocation()
  const ref = useRef()
  const onScreen = useOnScreen(ref, '300px')
  useEffect(() => {
    if (onScreen && showAmount < products.length) {
      setShowAmount(showAmount + 12)
    }
  }, [onScreen])

  useEffect(() => {
    setActiveFilters([])
  }, [pathname])

  const bikeActiveVariantFilter = variant => {
    const filtersArray = _.map(variant.filterValues, ov => ov.presentation)

    return (
      activeFilters.every(value => filtersArray.includes(value)) &&
      !variant.hideEverywhere
    )
  }

  return (
    <Grid
      gap={['2.4rem 1.6rem', null, '2.4rem']}
      sx={{
        gridTemplateColumns: [
          'repeat(2, 1fr)',
          'repeat(auto-fill, minmax(24rem, 1fr))',
          'repeat(auto-fill, minmax(28rem, 1fr))',
          'repeat(4, 1fr)'
        ],
        gridAutoRows: 'max-content',
        alignItems: 'flex-start'
      }}
    >
      {products
        .slice(0, showAmount)
        .map((product, i) =>
          product.productType?.slug !== 'electric-motorbike' ? (
            <QuickAddProductCard
              key={`${product.slug}-${i}`}
              product={product}
              collectionName={collectionName}
              lineup={lineup}
            />
          ) : (
            product.variants
              .filter(bikeActiveVariantFilter)
              .map((v, i) => (
                <BikeQuickAddCard
                  key={`bQuickAdd-${i}`}
                  product={product}
                  variant={v}
                  collectionName={collectionName}
                  lineup={lineup}
                />
              ))
          )
        )}
      <div ref={ref} />
    </Grid>
  )
}

export default ProductList
